<template>
    <svg
        :class="svgClass"
        aria-hidden="true"
    >
        <use :xlink:href="iconName" />
    </svg>
</template>
<script lang="ts" setup>
import {computed} from 'vue';

const props = defineProps({
    iconClass: {
        type: String,
        required: true
    },
    className: {
        type: String,
        default: () => ''
    }
});
const iconName = computed(() => {
    return `#icon-${props.iconClass}`;
});
const svgClass = computed(() => {
    if (props.className) {
        return `svg-icon ${props.className}`;
    } else {
        return 'svg-icon';
    }
});
</script>
<style>
.svg-icon {
    width: 1.6em;
    height: 1.6em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    border-radius: 2px;
}
.svg-icon.table-icon-style {
    background: #F5F7F9;
    border-radius: 2px;
    color: var(--el-color-primary);
}
.svg-icon.table-icon-style:hover,
.svg-icon.table-icon-style.active {
    background: rgba(0, 102, 255, 0.1);
}
</style>
